import React, { FC } from 'react';
import {
  FacebookShareButton,
  TelegramShareButton,
  TwitterShareButton,
} from 'react-share';

import {
  ShareImg,
  ShareMenu,
  ShareMenuPopup,
  ShareTitle,
  ShareWrapper,
  SocialIcon,
} from './styled';

import shareSvg from '../../../../static/images/ic_share.svg';
import telegram from '../../../../static/images/telegram.svg';
import twitter from '../../../../static/images/twitter.svg';
import facebook from '../../../../static/images/facebook.svg';

const Share: FC = () => {
  return (
    <ShareMenu
      trigger={
        <ShareWrapper>
          <ShareImg src={shareSvg} alt="share" />
          <ShareTitle>
            frields
            {/* <FormattedMessage id="thank-you.content.friends" /> */}
          </ShareTitle>
        </ShareWrapper>
      }
      position="bottom left"
      on="click"
      closeOnDocumentClick
      mouseLeaveDelay={300}
      mouseEnterDelay={0}
      contentStyle={{
        padding: '0px',
        border: 'none',
        width: '160px',
      }}
      arrow={false}
    >
      <ShareMenuPopup>
        <TelegramShareButton url="https://wallet.bitcoin.com">
          <SocialIcon src={telegram} alt="telegram" />
        </TelegramShareButton>
        <TwitterShareButton url="https://wallet.bitcoin.com">
          <SocialIcon src={twitter} alt="twitter" />
        </TwitterShareButton>
        <FacebookShareButton url="https://wallet.bitcoin.com">
          <SocialIcon src={facebook} alt="facebook" />
        </FacebookShareButton>
      </ShareMenuPopup>
    </ShareMenu>
  );
};

export default Share;
